// extracted by mini-css-extract-plugin
module.exports = {"swisstopomapcontainer":"Location_swisstopomapcontainer__2MIzu","swisstopomap":"Location_swisstopomap__1an68"};